module.exports = __webpack_public_path__ + "img/docker.4a0ebb6a.png";